// 参考网址：https://juejin.cn/post/6844903652881072141

// 在http.js中引入axios
import axios from 'axios'; // 引入axios
// import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据，后面会提到
// vant的toast提示框组件，大家可根据自己的ui组件更改。
// import { Toast } from 'vant'; 

import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);


// 环境的切换
if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = 'http://localhost:8080';
}
else if (process.env.NODE_ENV == 'debug') {
    // axios.defaults.baseURL = 'http://47.100.193.22:10033';
}
else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = 'https://webapi.giiloo.com';
}

// 设置请求超时时间
axios.defaults.timeout = 5000;

// post请求头的设置
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';


/* GET */
export function get(url, params) {
    if (params) {
        params.random = Math.random()
    } else {
        params = {
            random: Math.random()
        }
    }
    return new Promise((resolve, reject) => {
        axios({
            method: "get",
            url: url,
            params: params,
            headers: {
                'content-type': 'application/json', // 默认值
                'authorization': 'Bearer ' + localStorage.getItem('token'),
                'developer': 'Giiloo'
            }
        }).then(res => {
            if (res.data.code == 0) {
                resolve(res.data);
            } else if (res.data.code == 401) {
                getToken().then(() => {
                    // return get(url, params)
                    get(url, params).then(res401 => {
                        resolve(res401);
                    })
                }).catch(err => {
                    reject(res.data)
                    Toast({
                        message: "网络错误，请重试",

                    })
                })
            } else if (res.data.code == 1) {
                Toast({
                    message: res.data.message,
                })
                console.log("GET错误")
                console.log(res)
                reject(res.data)
            } else {
                Toast({
                    message: "网络错误，请重试",
                })
                console.log("GET错误")
                console.log(res)

                reject(res.data)
            }
        }).catch(err => {
            Toast({
                message: "网络超时，请重试",
                icon: 'none',
                duration: 2000
            })
            reject(res.data)

        })
    });
}


/* POST */
export function post(url, params) {
    let self = this
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: url,
            data: params,
            headers: {
                'content-type': 'application/json', // 默认值
                'authorization': 'Bearer ' + localStorage.getItem('token'),
                'developer': 'Giiloo'
            }
        }).then(res => {
            if (res.data.code == 0) {
                resolve(res.data);
            } else if (res.data.code == 401) {
                getToken().then(() => {
                    // return get(url, params)
                    get(url, params).then(res401 => {
                        resolve(res401);
                    })
                }).catch(err => {
                    reject(res.data)
                    Toast({
                        message: "网络错误，请重试",

                    })
                })
            } else if (res.data.code == 1) {
                Toast({
                    message: res.data.message,
                })
                console.log("POST错误")
                console.log(res)
                reject(res.data)
            } else {
                Toast({
                    message: "网络错误，请重试",
                })
                console.log("GET错误")
                console.log(res)

                reject(res.data)
            }
        }).catch(err => {
            Toast({
                message: "网络超时，请重试",
                icon: 'none',
                duration: 2000
            })
            reject(res.data)
        })
    });
}

/* verify */
export function verify(url, params) {
    let self = this
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: url,
            data: params,
            headers: {
                'content-type': 'application/json', // 默认值
                'developer': 'Giiloo'
            }
        }).then(res => {
            resolve(res);
        }).catch(err => {
            Toast({
                message: "网络超时，请重试",
                icon: 'none',
                duration: 2000
            })
            reject(res.data)
        })
    });
}


/* PUT */
export function put(url, params) {
    if (params) {
        params.random = Math.random()
    } else {
        params = {
            random: Math.random()
        }
    }
    return new Promise((resolve, reject) => {
        axios({
            method: "put",
            url: url,
            data: params,
            headers: {
                'content-type': 'application/json', // 默认值
                'authorization': 'Bearer ' + localStorage.getItem('token'),
                'developer': 'Giiloo'
            }
        }).then(res => {
            if (res.data.code == 0) {
                resolve(res.data);
            } else if (res.data.code == 401) {
                getToken().then(() => {
                    // return get(url, params)
                    get(url, params).then(res401 => {
                        resolve(res401);
                    })
                }).catch(err => {
                    reject(res.data)
                    Toast({
                        message: "网络错误，请重试",

                    })
                })
            } else if (res.data.code == 1) {
                Toast({
                    message: res.data.message,
                })
                console.log("PUT错误")
                console.log(res)
                reject(res.data)
            } else {
                Toast({
                    message: "网络错误，请重试",
                })
                console.log("GET错误")
                console.log(res)

                reject(res.data)
            }
        }).catch(err => {
            Toast({
                message: "网络超时，请重试",
                icon: 'none',
                duration: 2000
            })
            reject(res.data)
        })
    });
}


/* DELETE */
export function del(url, params) {
    return new Promise((resolve, reject) => {
        axios({
            method: "delete",
            url: url,
            data: params,
            headers: {
                'content-type': 'application/json', // 默认值
                'authorization': 'Bearer ' + localStorage.getItem('token'),
                'developer': 'Giiloo'
            }
        }).then(res => {
            console.log("2")
            console.log(res)
            if (res.data.code == 0) {
                resolve(res.data);
            } else if (res.data.code == 401) {
                getToken().then(() => {
                    // return get(url, params)
                    get(url, params).then(res401 => {
                        resolve(res401);
                    })
                }).catch(err => {
                    reject(res.data)
                    Toast({
                        message: "网络错误，请重试",

                    })
                })
            } else if (res.data.code == 1) {
                Toast({
                    message: res.data.message,
                })
                console.log("GET错误")
                console.log(res)
                reject(res.data)
            } else {
                Toast({
                    message: "网络错误，请重试",
                })
                console.log("DEL错误")
                console.log(res)

                reject(res.data)
            }
        }).catch(err => {
            Toast({
                message: "网络超时，请重试",
                icon: 'none',
                duration: 2000
            })
            reject(res.data)
        })
    });
}